import { Container } from '../components/container/container';

export function NotFound() {
  return (
    <Container>
      <h1>404 Page not found</h1>
    </Container>
  );
}
